module.exports = __webpack_public_path__ + "img/Dining.092a3f2f.svg";